import React from 'react'
import { ArrowsLeftRight } from '@phosphor-icons/react'

/**
 * Botón Tower: neutro por defecto; acepta cualquier color CSS.
 *
 * Ejemplo:
 * <UbiquaTowerBotonAction onClick={openBulkDialog} />
 * <UbiquaTowerBotonAction color="#ff893d" onClick={handleClick} />
 * <UbiquaTowerBotonAction color="yellow" textColor="#1c3552" onClick={handleClick} />
 */
export default function UbiquaTowerBotonAction({
  label = 'Reasignar roles',
  icon,
  onClick,
  disabled = false,
  color,
  textColor = color ? '#fff' : undefined,
  hoverColor,
  focusColor,
  type = 'button',
  className = '',
  ariaLabel
}) {
  const resolvedIcon = icon ?? <ArrowsLeftRight size={17} weight="regular" aria-hidden="true" />

  return (
    <button
      type={type}
      className={['ubiqua-tower-boton-action', className].filter(Boolean).join(' ')}
      style={{
        '--ubiqua-tower-boton-action-background': color,
        '--ubiqua-tower-boton-action-text': textColor,
        '--ubiqua-tower-boton-action-border': color,
        '--ubiqua-tower-boton-action-hover-background': hoverColor ?? color,
        '--ubiqua-tower-boton-action-hover-border': hoverColor ?? color,
        '--ubiqua-tower-boton-action-focus': focusColor ?? color
      }}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || label}
    >
      {resolvedIcon}
      <span className="ubiqua-tower-boton-action__label">{label}</span>
    </button>
  )
}

export { UbiquaTowerBotonAction }
